import { render } from "./paid-coffee.vue?vue&type=template&id=d6967bf8&lang=pug"
import script from "./paid-coffee.vue?vue&type=script&lang=js"
export * from "./paid-coffee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__